import React from "react";

// import { SideImage } from "./SideImage";

import { ForgotPassword } from "./forgot-password/ForgotPassword";
import { Login } from "./login/Login";
import { Signup } from "./signup/Signup";
import { VerifyAccount } from "./verify-account/VerifyAccount";
import { ResetPassword } from "./reset-password/resetPassword";
// import { useBackgroundImage } from "./useBackgroundImage.hook";

import "./AuthWrapper.css";
// import Logo from "../../assets/images/oa-logo.png";
// import SimpleLogo from '../../assets/images/oa-logo-simple.svg';
import LogoKeys from '../../assets/images/oa-logo-keys.svg';

const LOCATIONS = {
  login: "/login",
  signup: "/signup",
  forgotPassword: "/forgot-password",
  verifyAccount: "/verify-account/:token",
  resetPassword: "/reset-password/:token",
};

const AuthWrapper = ({ location, history, match }) => {
  const isLoginPage = location.pathname === LOCATIONS.login;
  const isSignupPage = location.pathname === LOCATIONS.signup;
  const isForgotPasswordPage = location.pathname === LOCATIONS.forgotPassword;
  const isVerifyAccountPage = match.path === LOCATIONS.verifyAccount;
  const isResetPassword = match.path === LOCATIONS.resetPassword;

  // const bgImage = useBackgroundImage();

  // useEffect(() => {
  //   document.body.style.backgroundColor = "white";

  //   return () => {
  //     // document.body.style.backgroundColor = "rgb(238, 241, 245)";
  //   };
  // }, []);

  const getFormHeading = () => {
    switch (location.pathname) {
      case LOCATIONS.login:
        return "Log in to your account";

      case LOCATIONS.signup:
        // return "Sign up for an account";
        return "Ready to Get Organized?";

      case LOCATIONS.forgotPassword:
        return "Forgot Password?";

      case LOCATIONS.resetPassword:
        
        return "Reset New Password?";

      default:
        if (location.pathname.includes('reset-password')) { 
          return "Reset New Password?";
        }
        if (location.pathname.includes('verify-account')) {
          return "Verify Account";
        }

        return "";
    }
  };

  const getHeadingButton = () => {
    switch (location.pathname) {
      case LOCATIONS.login:
        return {
          text: 'Don\'t have an account?',
          label: "Sign up for a free trial",
          onClick: () => (window.location.href = `/app${LOCATIONS.signup}`),
        };

      case LOCATIONS.signup:
        return {
          text: 'Already have an account?',
          label: "Login",
          onClick: () => (window.location.href = `/app${LOCATIONS.login}`),
        };

      case LOCATIONS.forgotPassword:
        return {
          text: 'Remembered your password?',
          label: "Login",
          onClick: () => (window.location.href = `/app${LOCATIONS.login}`),
        };

      default:
        return {
          label: "Login",
          onClick: () => (window.location.href = `/app${LOCATIONS.login}`),
        };
    }
  };

  const headingButton = getHeadingButton();

  return (
    <div className="tw-h-screen tw-bg-white tw-flex tw-flex-col tw-justify-center tw-px-6 tw-py-12 lg:tw-px-8">
      <div className="sm:tw-max-w-sm sm:tw-mx-auto sm:tw-w-full">
        <a href="https://organizedadjusting.com">
        <img
          className="tw-mx-auto"
          style={{ width: 100 }}
          src={LogoKeys}
          alt="Organized Adjusting Logo"
        /></a>
        <h1 className="tw-mt-10 tw-text-center tw-text-2xl/9 tw-font-bold tw-text-gray-900 tw-tracking-tight">{getFormHeading()}</h1>
      </div>

      <div className="tw-mt-10 sm:tw-max-w-sm sm:tw-mx-auto sm:tw-w-full">
        {isLoginPage && (
          <Login
            goToForgotPassword={() =>
              (window.location.href = `/app${LOCATIONS.forgotPassword}`)
            }
          />
        )}
        {isSignupPage && (
          <Signup
            goToLoginPage={() => history.push(`${LOCATIONS.login}`)}
          />
        )}

        {isForgotPasswordPage && <ForgotPassword />}
        {isVerifyAccountPage && <VerifyAccount match={match} />}
        {isResetPassword && <ResetPassword match={match} />}
      </div>

      <div className="tw-mt-10 sm:tw-max-w-sm sm:tw-mx-auto sm:tw-w-full">
        <p className="tw-text-center tw-text-sm/6 tw-text-gray-500">
        {headingButton.text}{" "} 
            <button
              className="tw-bg-transparent tw-font-semibold tw-text-blue-500 hover:tw-text-blue-400 hover:tw-no-underline"
              onClick={headingButton.onClick}
            >
              {headingButton.label}
            </button>
        </p>
          
      </div>

    </div>
  );
};

export default AuthWrapper;
